import { Directive, Injectable } from '@angular/core';
import { Validator, FormControl } from '@angular/forms';

@Injectable()
export class NotValueValidatorDirective implements Validator {
    validator: Function;

    constructor() {
        this.validator = NotValueValidatorDirective.notValueValidatorFactory('');
    }

    validate(c: FormControl) {
        return this.validator(c);
    }

    static notValueValidatorFactory(notValue: any) {
        return (c: FormControl) => {
        const exactMatch = c.value === notValue;
        //console.log(`notValueValidator: CurrentVal: ${c.value}, 'Not' value: ${notValue}.  Result: ${exactMatch}`);
        return !exactMatch ? null : { notValueValidator: true };
        }
    }
}
